<div class="container pt-2" *ngIf="user">
	<div class="row">
		<div class="col-12 rounded-xl p-3 shadow-kp pointer mt-3">
			<div class="row">
				<div class="col-12">
					<span *ngIf="user.Agent.Code" class="float-left fs-sm">کد: {{user.Agent.Code}}</span>
					<img [src]="user.Agent.Logo" class="rounded-circle float-right ml-2" width="100" height="100">
					<h2><a [routerLink]="['/agent',user.Agent.Code]">{{title}}
							{{user.Agent.IsLegal?'(حقوقی)':''}}</a></h2>
					<a class="bold" [routerLink]="['/agent',{l:Utility.join('،',user.Agent.State,user.Agent.City)}]">
						{{Utility.join('، ',user.Agent.State,user.Agent.City,user.Agent.District)}}</a>
					<div class="fs-sm" *ngIf="hasDate(user.Agent.EstablishDate)">تاسیس {{user.Agent.EstablishDate|pdate:'[yyyy]'}}
					</div>
				</div>
				<div class="col-12 m-1" [innerHtml]="user.Agent.Description"></div>
				<div class="col-12"><strong>آدرس:</strong> {{user.Agent.Address}}</div>
				<div class="col-12" *ngIf="user.Agent.Phones?.length">
					<strong>تلفن:</strong> <a *ngFor="let tel of user.Agent.Phones" href="tel:+{{tel}}">&nbsp;<span
							dir="ltr">{{tel}}</span>&nbsp;</a>
				</div>
				<div class="col-12"><strong>مدیریت:</strong> {{user.Agent.Manager}}</div>
				<!-- <div class="col-12" *ngIf="user.Agent.Faxes?.length">
					فکس: <a *ngFor="let tel of user.Agent.Faxes" href="tel:+{{tel}}"><span
							dir="ltr">{{tel}}</span>&nbsp;&nbsp;</a>
				</div> -->
			</div>
		</div>
	</div>
	<job-list [criteria]="criteria" [loadMoreEnabled]="true"></job-list>
</div>